import React from 'react';
import { styled } from '@linaria/react';

import Spacer from '@/components/Spacer';

const SpringComparison = ({
  children,
  background = 'var(--color-gray-100)',
  scoochCloser,
}) => {
  const [spring1, spring2] = React.Children.toArray(children);

  return (
    <Wrapper
      data-scooch-closer={String(!!scoochCloser)}
      style={{
        '--bg': background,
      }}
    >
      {spring1}
      <Spacer size={8} />
      {spring2}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 48px;
  border-radius: 12px;
  max-width: 500px;
  background: var(--bg);

  @media (max-width: 500px) {
    width: 100%;
    justify-content: center;

    &[data-scooch-closer='true'] {
      background: transparent;

      & > *:first-child {
        transform: translateX(32px);
      }
      & > *:last-child {
        transform: translateX(-32px);
      }
    }
  }
`;

export default SpringComparison;
